// This variable is automatically updated by jenkins once there's a change on any Slice file, no need to manually change it.
const CURRENT_STORE_VERSION = 12;
export default CURRENT_STORE_VERSION;
